const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const uppercase = (str) => str.toUpperCase();

const lowercase = (str) => str.toLowerCase();

const alt = (str) => {
  if (str === undefined) return "0";
  return str;
};
const courseFilter = (items = [], searchText = "") => {
  if (!items) return [];
  if (!searchText) return items;
  return items.filter((item) => item.course_id == searchText);
};
const currencyFilter = (currency) => {
  if (!isNaN(parseFloat(currency))) {
    return parseFloat(currency)
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  } else {
    return 0;
  }
};

export const filters = {
  capitalize,
  uppercase,
  lowercase,
  alt,
  courseFilter,
  currencyFilter,
};
